import { render, staticRenderFns } from "./ProhibitedCategories.vue?vue&type=template&id=bd249b64&scoped=true&"
import script from "./ProhibitedCategories.vue?vue&type=script&lang=js&"
export * from "./ProhibitedCategories.vue?vue&type=script&lang=js&"
import style0 from "./ProhibitedCategories.vue?vue&type=style&index=0&id=bd249b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd249b64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd249b64')) {
      api.createRecord('bd249b64', component.options)
    } else {
      api.reload('bd249b64', component.options)
    }
    module.hot.accept("./ProhibitedCategories.vue?vue&type=template&id=bd249b64&scoped=true&", function () {
      api.rerender('bd249b64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/forbidTheSale/modules/ProhibitedCategories.vue"
export default component.exports